module.exports = __webpack_public_path__ + "media/service_features/increased_reward-15c54755.svg";